/* begin general import */
import { Spin } from "antd";
import { MenuFilter } from "models/Menu";
import { MenuReportFilter } from "models/MenuReport";
import { SiteFilter } from "models/Site";
import React from "react";
import { IdFilter } from "react3l-advanced-filters";
import {
  AdvanceIdFilterMaster,
  Pagination,
  StandardTable,
  TagFilter,
} from "react3l-ui-library";
import InputSearch from "react3l-ui-library/build/components/Input/InputSearch";
import { menuReportRepository } from "repositories/menu-report-repository";
import nameof from "ts-nameof.macro";
import { useMenuReportMasterHook } from "./MenuReportMasterHook";
/* end individual import */

function FileTemplateMaster() {
  const {
    translate,
    handleChangeSelectFilter,
    handleChangeInputSearch,
    handleTableChange,
    handlePagination,
    handleChangeAllFilter,
    validAction,
    filter,
    selectedRowKeys,
    columns,
    list,
    count,
    loadingList,
  } = useMenuReportMasterHook();

  return (
    <>
      <Spin spinning={false}>
        <div className="page-content page-content-dxg" id="page-content-dxg-id">
          <div className="info-component ml-4 mb-3">
            <span>{translate("menuReports.master.header")}</span>
            <span> &gt; </span>
            <span className="info-primary">
              {translate("menuReports.master.subHeader")}
            </span>
          </div>

          <div className="page page-master m-b--xxs">
            <div className="pb-3 ml-3 pt-4">
              <h5 className="font-bold page-title">
                {translate("menuReports.master.subHeader")}
              </h5>
            </div>

            <div className="page-master__content">
              <div className="page-master__tag-filter">
                <TagFilter
                  value={filter}
                  translate={translate}
                  keyTranslate={"menuReports"}
                  handleChangeFilter={handleChangeAllFilter}
                  onClear={() => {
                    return 0;
                  }}
                />
              </div>
              {(!selectedRowKeys || selectedRowKeys?.length === 0) && (
                <div className="page-master__filter-wrapper d-flex align-items-center justify-content-between px-3">
                  <div className="page-master__filter d-flex align-items-center justify-content-start">
                    {validAction("filterListSite") && (
                      <div className="">
                        <AdvanceIdFilterMaster
                          value={filter[nameof(list[0].siteId)]["equal"]}
                          placeHolder={translate(
                            "menuReports.placeholder.site"
                          )}
                          classFilter={SiteFilter}
                          onChange={handleChangeSelectFilter({
                            fieldName: nameof(list[0].site),
                            fieldType: "equal",
                            classFilter: IdFilter,
                          })}
                          getList={menuReportRepository.filterListSite}
                          label={translate("menuReports.site")}
                        />
                      </div>
                    )}
                    {validAction("filterListMenu") && (
                      <div className="">
                        <AdvanceIdFilterMaster
                          value={filter[nameof(list[0].menuId)]["equal"]}
                          placeHolder={translate(
                            "menuReports.placeholder.menu"
                          )}
                          classFilter={MenuFilter}
                          onChange={handleChangeSelectFilter({
                            fieldName: nameof(list[0].menu),
                            fieldType: "equal",
                            classFilter: IdFilter,
                          })}
                          getList={menuReportRepository.filterListMenu}
                          label={translate("menuReports.menu")}
                        />
                      </div>
                    )}
                  </div>
                  <div className="page-master__filter-action-search d-flex align-items-center">
                    <InputSearch
                      value={filter.search}
                      classFilter={MenuReportFilter}
                      placeHolder={translate("general.placeholder.search")}
                      onChange={handleChangeInputSearch}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="page-master__content-table">
              <StandardTable
                rowKey={nameof(list[0].id)}
                columns={columns}
                dataSource={list}
                isDragable={true}
                tableSize={"md"}
                onChange={handleTableChange}
                spinning={loadingList}
                scroll={{ x: 1000 }}
              />
              <Pagination
                skip={filter?.skip}
                take={filter?.take}
                total={count}
                onChange={handlePagination}
              />
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
}
export default FileTemplateMaster;
